export function acChangeActiveLot(val) {
    return {
        type: 'ACTIVE_LOT',
        payload: val
    }

}
